import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = '查看全部',
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2 text-lg md:text-xl font-bold text-foreground-950">
          {icon && (
            <span className="w-7 h-7 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
              <i className={`${icon} text-base`}></i>
            </span>
          )}
          <span className="truncate">{title}</span>
        </h2>
        {subtitle && (
          <p className="text-xs md:text-sm text-foreground-500 mt-1.5">{subtitle}</p>
        )}
      </div>
      {children}
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-xs md:text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}